import { Component, Input, OnInit, Inject } from "@angular/core";

import { RoleTypeDataService } from "../../../core/jobroletypes.dataservice";
import { CrewPermissionsService } from "../../../core/crew-permissions.service";

@Component({
    selector: "crew-person-roles",
    template: require('./person.roles.component.html')
})
export class PersonRolesComponent implements OnInit {

    isPermissionWriteOrAdmin: boolean;

    constructor(
        @Inject(RoleTypeDataService.Id) private roleDataService: RoleTypeDataService,
        private crewPermissionsService: CrewPermissionsService) { }

    roleTypes: Nema.Crew.Model.RoleType[];

    @Input()
    person: Nema.Crew.Model.Person;

    ngOnInit() {
        this.crewPermissionsService.isPermissionWriteOrAdmin().subscribe(value => this.isPermissionWriteOrAdmin = value);
        
        this.roleDataService
            .getAll()
            .then(res => {
                this.roleTypes = res;

                (<any>this.person.PersonRoles).load();
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/roles/person.roles.component.ts